@use '@/styles/mastodon/mixins';

// If hovering over an account link, underline all account links.
.title:has(.quoteAccountLink:hover) {
  .accountLink {
    text-decoration: underline;
  }
}

.spoiler {
  background: var(--color-bg-highlight);
  border-radius: var(--radius-sm);
  margin: var(--space-2xs) 0;
  padding: var(--space-xs);
}

.body {
  @include mixins.type-body;

  color: inherit;
  text-decoration: none;

  p:not(:last-child) {
    margin-block-end: 1em;
  }

  // If a body only has an empty div (such as when quoting just a link), just hide it.
  &:has(> div:only-child:empty) {
    display: none;
  }

  strong {
    font-weight: bold;
  }
}

.reply {
  color: var(--color-text-tertiary);
  margin-bottom: var(--space-xs);
}

.media {
  margin-top: var(--space-2xs);
}

.mediaGrid {
  display: grid;
  height: 260px;
  gap: var(--space-3xs);
  grid-template-columns: repeat(2, 1fr);
  grid-template-rows: repeat(2, 1fr);
  aspect-ratio: 3/2;

  &[data-number='2'] {
    grid-template-rows: 1fr;
  }

  &[data-number='3'] .mediaUpload:first-child {
    grid-row: span 2;
  }
}

.mediaSingle .image {
  min-width: 120px;
  max-width: min(100%, 400px);
  aspect-ratio: var(--aspect);
}

.image {
  max-height: 260px;
  border-radius: var(--radius-xs);
}

.videoDuration {
  @include mixins.type-label-md;

  display: flex;
  gap: var(--space-2xs);
  align-items: center;
  position: absolute;
  inset-block-end: var(--space-xs);
  inset-inline-start: var(--space-xs);
  padding: var(--space-2xs) var(--space-3xs);
  background: var(--color-bg-highlight);
  border-radius: var(--radius-xs);
  color: var(--color-text-primary);

  svg {
    width: 16px;
    height: 16px;
    opacity: 0.7;
  }
}

.error {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}

.errorButton {
  flex-shrink: 0;
}

.infoPopup {
  padding: var(--space-sm);
}
